import { createCouponsQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useCouponsContentQuery = createCouponsQuery(HTTP_CONFIG.API.Optimizely.url)
